<template>
  <div class="page">
    <unifiedHeader />
    <div class="background">
      <!-- <div class="login" style="display:none;"> -->
      <div class="login">
        <div class="top">熊洞智家 | 通行证</div>
        <div class="main">
          <div class="maeu">
            <span
              :class="{ 'span-on': key == ind }"
              @click="active(key)"
              v-for="(val, key) in meauList"
              :key="key"
              >{{ val.name }}</span
            >
          </div>
          <div class="Mmaeu">
            <span
              :class="{ 'span-on': key == ind }"
              @click="active(key)"
              v-for="(val, key) in meauList"
              :key="key"
              >{{ val.name }}</span
            >
          </div>
          <div class="middle" v-if="ind == 0">
            <el-form data-vv-scope="pwdLogin">
              <!-- <el-form-item :error="errorBags.collect('pwdLogin.手机号')[0]"> -->
              <el-form-item>
                <el-input
                  v-model="pwdLogin.mobile"
                  placeholder="手机号/用户名/邮箱"
                  @blur="blurBack"
                  v-validate="'required|phone'"
                ></el-input>
              </el-form-item>
              <el-form-item :error="errorBags.collect('pwdLogin.密码')[0]">
                <el-input
                  v-model="pwdLogin.password"
                  placeholder="请输入密码"
                  @blur="blurBack"
                  show-password
                  v-validate="'required'"
                  name="密码"
                ></el-input>
              </el-form-item>
              <div class="captcha">
                <el-form-item :error="errorBags.collect('pwdLogin.验证码')[0]">
                  <el-input
                    v-model="captchaText"
                    placeholder="请输入验证码"
                    @blur="blurBack"
                    v-validate="'required'"
                    name="验证码"
                  ></el-input>
                </el-form-item>
                <img :src="serialImg" alt @click="getCaptcha" />
              </div>
              <div class="butn" @click="login">登录</div>
              <div class="bottom">
                <div class="bottom-left">
                  <el-checkbox
                    @click="CheckItem(autoLogin)"
                    v-model="autoLogin.state"
                    >下次自动登录</el-checkbox
                  >
                </div>
                <div class="bottom-right">
                  <span class="hover" @click="toRetrievePassword"
                    >忘记密码</span
                  >
                  <span class="span-on">|</span>
                  <span class="hover" @click="toRegister">注册</span>
                </div>
              </div>
            </el-form>
          </div>
          <div class="middle" v-if="ind == 1">
            <el-form data-vv-scope="capLogin">
              <el-form-item :error="errorBags.collect('capLogin.手机号')[0]">
                <el-input
                  v-model="capLogin.mobile"
                  placeholder="请输入您的手机号"
                  @blur="blurBack"
                  v-validate="'required|phone'"
                  maxlength="11"
                  name="手机号"
                ></el-input>
              </el-form-item>
              <div class="captcha">
                <el-form-item>
                  <el-input
                    v-model="captchaText"
                    placeholder="请输入验证码"
                    @blur="blurBack"
                    name="验证码"
                  ></el-input>
                </el-form-item>
                <img :src="serialImg" alt @click="getCaptcha" />
              </div>
              <el-form-item :error="errorBags.collect('capLogin.验证码')[0]">
                <div class="captchaDx">
                  <el-input
                    v-model="capLogin.verifyCode"
                    v-validate="'required'"
                    @blur="blurBack"
                    name="验证码"
                  ></el-input>
                  <el-button
                    :disabled="disabled"
                    type="primary"
                    plain
                    @click="flag && sendcode($event)"
                    >获取验证码</el-button
                  >
                </div>
              </el-form-item>
              <div class="butn" @click="login">登录</div>
              <div class="bottom">
                <div class="bottom-left">
                  <el-checkbox
                    @click="CheckItem(autoLogin)"
                    v-model="autoLogin.state"
                    >下次自动登录</el-checkbox
                  >
                </div>
                <div class="bottom-right">
                  <span class="hover" @click="toRetrievePassword"
                    >忘记密码</span
                  >
                  <span class="span-on">|</span>
                  <span class="hover" @click="toRegister">注册</span>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div class="trilateral">
          <span>第三方账号登录</span>
          <div class="thrImg">
            <img
              :src="greyWX"
              alt
              @click="clickWX($event)"
              @mouseenter="enterWX($event)"
              @mouseleave="leaveWX($event)"
            />
            <img
              :src="greyWB"
              alt
              @click="clickWB($event)"
              @mouseenter="enterWB($event)"
              @mouseleave="leaveWB($event)"
            />
            <img
              :src="greyQQ"
              alt
              @click="clickQQ($event)"
              @mouseenter="enterQQ($event)"
              @mouseleave="leaveQQ($event)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      熊洞智家 智能家居服务平台 熊洞智家（北京）科技有限公司/无忧服务 版权所有
    </div>
  </div>
</template>
<script>
import { loginApi, authApi } from '@/api/';
import { mapActions } from 'vuex';
import { USER_SIGNIN, USER_SIGNOUT } from '@/store/auth';
import captcha from '@/mixins/captcha';
import blurBack from '@/mixins/blurBack';
import unifiedHeader from '@/components/common/unifiedHeader'; // 统一头部
import store from '@/store';
export default {
  mixins: [blurBack, captcha],
  data() {
    return {
      pwdLogin: {
        mobile: '',
        password: '',
        captchaText: '',
        loginType: 1,
        captchaSerialNum: '',
        userType: 1
      },
      capLogin: {
        mobile: '',
        verifyCode: '',
        smsType: 2,
        loginType: 2,
        userType: 1
      },
      ind: 0,
      flag: true,
      meauList: [{ name: '密码登录' }, { name: '短信登录' }],
      serialImg: '',
      greyWB: require('../../assets/login/grey_weibo.png'),
      greyWX: require('../../assets/login/grey_weixin.png'),
      greyQQ: require('../../assets/login/grey_qq.png'),
      autoLogin: [],
      disabled: false,
      state: ''
    };
  },
  components: {
    unifiedHeader
  },
  watch: {
    $route: {
      handler(val) {
        this.getCaptcha();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions([USER_SIGNIN, USER_SIGNOUT]),
    // 判断是否自动登录
    CheckItem(autoLogin) {
      autoLogin.state = !autoLogin.state;
      if (this.autoLogin.state === true) {
        // 自动登录
      }
    },
    // 忘记密码
    toRetrievePassword() {
      this.$router.push({
        path: '/form/retrievePassword'
      });
    },
    // 注册
    toRegister() {
      this.$router.push({
        path: '/register'
      });
    },
    // 鼠标移入微信
    enterWX() {
      this.greyWX = require('../../assets/login/bright_weixin.png');
    },
    // 鼠标移出微信
    leaveWX() {
      this.greyWX = require('../../assets/login/grey_weixin.png');
    },
    // 点击微信// id和scope不用改、appid和redirect_uri改为自己的
    clickWX() {
      this.wxState(1).then(data => {
        // let url = encodeURI(`${process.env.VUE_APP_ID_URL}/bind/wx`)
        let url = encodeURI('https://id.juranguanjia.com/wxbindxx');
        window.location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wxf386957290ae6e88&redirect_uri=${url}&scope=snsapi_login&state=${
          this.state
        }&response_type=code#wechat_redirect`;
      });
    },
    // 鼠标移入微博
    enterWB() {
      this.greyWB = require('../../assets/login/bright_weibo.png');
    },
    // 鼠标移出微博
    leaveWB() {
      this.greyWB = require('../../assets/login/grey_weibo.png');
    },
    // 点击微博
    clickWB() {
      this.wxState(3).then(data => {
        let url = encodeURI(`${process.env.VUE_APP_ID_URL}/bind/wb`);
        window.location.href = `https://api.weibo.com/oauth2/authorize?client_id=403096172&response_type=code&redirect_uri=${url}`;
      });
    },
    // 鼠标移入QQ
    enterQQ() {
      this.greyQQ = require('../../assets/login/bright_qq.png');
    },
    // 鼠标移出QQ
    leaveQQ() {
      this.greyQQ = require('../../assets/login/grey_qq.png');
    },
    // 点击QQ
    clickQQ() {
      this.$message.error('开发中，请敬请期待！');
      // this.wxState(2).then((data) => {
      //   let url = encodeURI('https://id.juranguanjia.com/bind/qq')
      //   window.location.href = `https://graph.qq.com/oauth2.0/authorize?client_id=101575678&redirect_uri=${url}&state=${this.state}&response_type=code`
      // })
    },
    // 获取state
    async wxState(type) {
      let params = {
        thirdLoginType: type
      };
      try {
        let data = (await authApi.getState(params)).data;
        if (data.statusCode === 200) {
          this.state = data.data;
        }
      } catch (err) {
        console.error(err);
      } finally {
      }
    },
    // meau切换
    active(key) {
      this.ind = key;
    },
    // 发送手机验证码
    async sendcode(event) {
      if (!this.captchaText) {
        this.$message.error('请输入图形验证码！');
        return;
      }
      this.disabled = true;
      let el = event.currentTarget;
      let waitTime = 60;

      try {
        let params = {
          mobile: this.capLogin.mobile,
          smsType: 2,
          captchaText: this.captchaText,
          captchaSerialNum: this.captchaSerialNum
        };
        let data = (await loginApi.sendcode(params)).data;
        if (data.statusCode === 200) {
          this.dingshiqi(el, waitTime);
          this.$message.success('短信验证码已发送，请在1分钟后获取！');
        }
      } catch (err) {
        console.error(err);
        this.disabled = false;
      } finally {
      }
    },
    // 定时器
    dingshiqi(el, waitTime) {
      if (waitTime === 0) {
        this.flag = true;
        el.innerHTML = '重新获取验证码';
        waitTime = 60; // 恢复计时
        this.disabled = false;
        clearTimeout(() => {
          this.dingshiqi(el, waitTime);
        }, 1000);
      } else {
        el.innerHTML = waitTime + 's后重新发送';
        waitTime--;
        setTimeout(() => {
          this.dingshiqi(el, waitTime);
        }, 1000);
        this.flag = false;
      }
    },
    // 密码登录
    async login() {
      if (this.ind === 0) {
        if (
          this.pwdLogin.mobile
          && this.pwdLogin.password
          && this.captchaText
        ) {
          this.pwdLogin.captchaText = this.captchaText;
          this.pwdLogin.captchaSerialNum = this.captchaSerialNum;
          this.LoginCommon(this.pwdLogin);
        } else {
          this.$message.error('请确认信息填写正确');
        }
      } else {
        this.$validator.validateAll('capLogin').then(status => {
          if (status) {
            this.LoginCommon(this.capLogin);
          } else {
            this.$message.error('请确认信息填写正确');
          }
        });
      }
    },
    async LoginCommon(params) {
      try {
        let data = (await loginApi.login(params)).data;
        if (data.statusCode === 200) {
          this.USER_SIGNIN(data.data);
          let userType = store.state.Role.role
            ? store.state.Role.role
            : this.$route.query.userType;
          if (userType - 0 === 2 || userType - 0 === 4 || userType - 0 === 5) {
            this.$router.push({
              path: '/worker/workerInfo?userType=' + userType
            });
          } else {
            history.go(0);
            this.$router.push({
              path: '/check'
            });
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
      }
    }
  }
};
</script>
<style scoped>
#login_container {
  width: 300px;
  height: 300px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin: 0;
  transform: translate(-50%, -50%);
  border: 1px solid red;
}
.page {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  margin: 0;
  overflow: inherit;
}
.background {
  width: 100%;
  height: 100%;
  background: #f4f4f4;
  /* background: url(../../assets/login/banner.png) top center no-repeat; */
  /* background-size: cover; */
}
.background .login {
  width: 15rem;
  /* height: 15rem; */
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 8px;
  transform: translate(-50%, -60%);
  /* box-shadow:0px 2px 7px 0px rgba(204,204,204,1); */
}
.top {
  background: #ee8e38;
  color: #fff;
  font-size: 0.89rem;
  width: 100%;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  border-radius: 8px 8px 0 0;
}
.main {
  padding: 0 1rem;
  width: 100%;
  margin-top: 0.52rem;
}
.main .maeu {
  width: 100%;
  height: 1.56rem;
  line-height: 1.56rem;
  color: #999999;
  font-size: 0.8rem;
  border-bottom: 0.07rem solid #f4f4f4;
}
.main .maeu span {
  height: 1.56rem;
  line-height: 1.56rem;
  display: inline-block;
  cursor: pointer;
}
.main .maeu span:first-child {
  margin-right: 1.56rem;
}
.main .maeu .span-on {
  border-bottom: 0.07rem solid #333333;
  color: #333333;
}
.main .middle {
  margin-top: 2rem;
  height: 12rem;
}
.main .middle >>> .el-input--suffix {
  height: 1.64rem;
  line-height: 1.64rem;
  margin-bottom: 1rem;
  font-size: 0.52rem;
  background: #f4f4f4;
}
.main .middle >>> .el-input__inner {
  height: 1.64rem;
  line-height: 1.64rem;
  margin-bottom: 1rem;
  font-size: 0.52rem;
  background: #f4f4f4;
}
.main .middle .captcha {
  display: flex;
  justify-content: space-between;
}
.main .middle .captcha >>> .el-input__inner {
  width: 7.74rem;
  background: #f4f4f4;
}
.main .middle .captcha img {
  width: 4rem;
  height: 1.64rem;
}
.main .middle .captchaDx {
  display: flex;
  justify-content: flex-start;
}
.main .middle .captchaDx >>> .el-input {
  width: 7.74rem;
  color: #333333;
}
.main .middle .captchaDx >>> .el-button {
  height: 1.64rem;
  line-height: 1.64rem;
  padding: 0 10px;
  margin-left: 1.2rem;
  font-size: 0.52rem;
  width: 4rem;
}
.captchaDx span {
  height: 1.64rem;
  display: inline-block;
  background: #ee8e38;
  line-height: 1.64rem;
  color: #ffffff;
  font-size: 0.52rem;
  margin-left: 0.52rem;
  border-radius: 4px;
  padding: 0 1rem;
}
.main .middle .butn {
  width: 100%;
  height: 1.64rem;
  background: #ee8e38;
  color: #ffffff;
  line-height: 1.64rem;
  text-align: center;
  font-size: 0.6rem;
  font-weight: 500;
  border-radius: 4px;
  margin-bottom: 1rem;
  cursor: pointer;
}
.main .middle .bottom {
  display: flex;
  justify-content: space-between;
  font-size: 0.52rem;
}
.main .middle .bottom .bottom-left {
  color: #333;
}
.main
  .middle
  .bottom
  .bottom-left
  >>> .el-checkbox__input.is-checked
  + .el-checkbox__label {
  color: #333;
}
.main .middle .bottom .bottom-right {
  color: #999;
}
.main .middle .bottom .bottom-right span.hover {
  cursor: pointer;
}
.main .middle .bottom .bottom-right span.hover:hover {
  color: #333;
}
.main .middle .bottom .bottom-right .span-on {
  margin: 0 0.52rem;
  display: inline-block;
  cursor: default;
}
.trilateral {
  margin-top: 3rem;
  text-align: center;
  width: 100%;
  height: 4rem;
  color: #999999;
  font-size: 0.6rem;
}
.trilateral img {
  width: 2rem;
  height: 2rem;
  display: inline-block;
  margin-top: 0.52rem;
  cursor: pointer;
}
.trilateral img:nth-child(2) {
  margin: 0 1rem;
  margin-top: 0.52rem;
}
.footer {
  width: 100%;
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  padding: 0.8rem 0;
  color: #666666;
  font-size: 0.6rem;
  border-top: 1px solid #cccccc;
}
.footer .nav {
  margin-bottom: 0.6rem;
}
.footer .nav span {
  padding: 0 0.5rem;
  border-right: 0.05rem solid #666666;
  cursor: pointer;
}
.footer .nav span:last-child {
  border-right: 0;
}

@media screen and (max-width: 750px) {
  .footer {
    display: none;
  }
  .background {
    background: #fff;
  }
  .background .login {
    top: 60%;
  }
  .top {
    display: none;
  }
}
.el-form-item {
  margin-bottom: 0 !important;
}
.Mmaeu {
  width: 100%;
  color: #333;
  height: 1rem;
  line-height: 1rem;
  text-align: left;
  font-size: 1rem;
  display: none;
  cursor: pointer;
}
.Mmaeu span {
  margin-right: 35px;
  color: #999;
}
.Mmaeu .span-on {
  color: #333333;
}
@media screen and (max-width: 750px) {
  .maeu {
    display: none;
  }
  .Mmaeu {
    display: block;
  }
}
</style>
<style lang="less">
.el-form-item__error {
  top: 65% !important;
}
</style>
